<template>
  <div class="container admin">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>信息查询</el-breadcrumb-item>
        <el-breadcrumb-item>参数管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">参数管理</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handleParamCreate"
          >添加一级参数</el-button>
        </div>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <el-table
        :data="rules"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        border
        default-expand-all
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <!--       <el-table-column
          prop="id"
          label="ID"
          min-width="80"
          align="center"
        >

        </el-table-column> -->
        <el-table-column
          prop="name"
          label="名称"
          min-width="160"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="unit"
          label="单位"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{scope.row.unit || '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="类型"
          min-width="80"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{scope.row.type==1?'目录':'参数'}}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="图标"
          min-width="160"
          align="center"
        >
          <template slot-scope="scope">
            <el-image
              style="width: 25px; height: 25px"
              :src="scope.row.icon_url"
              v-if="scope.row.icon_url"
            ></el-image>
            <span v-else>/</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="code"
          label="编码"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="状态"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              size="mini"
              :type="scope.row.status == 1?'success':'danger'"
            >{{scope.row.status == 1 ? '正常' : '禁用'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="is_ref_college"
          label="院校"
          min-width="80"
          align="center"
        >
          <template slot-scope="scope">
            <!--     <span>{{scope.row.is_ref_college?'√':'否'}}</span> -->
            <i
              class="el-icon-check"
              v-if="scope.row.is_ref_college"
            ></i>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column
          prop="is_ref_major"
          label="专业"
          min-width="80"
          align="center"
        >
          <template slot-scope="scope">
            <!--     <span>{{scope.row.is_ref_major?'是':'否'}}</span> -->
            <i
              class="el-icon-check"
              v-if="scope.row.is_ref_major"
            ></i>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column
          prop="is_ref_year"
          label="年份"
          min-width="80"
          align="center"
        >
          <template slot-scope="scope">
            <!--      <span>{{scope.row.is_ref_year?'是':'否'}}</span> -->
            <i
              class="el-icon-check"
              v-if="scope.row.is_ref_year"
            ></i>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column
          prop="is_ref_multi"
          label="列表"
          min-width="80"
          align="center"
        >
          <template slot-scope="scope">
            <!--         <span>{{scope.row.is_ref_multi?'是':'否'}}</span> -->
            <i
              class="el-icon-check"
              v-if="scope.row.is_ref_multi"
            ></i>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否为系统参数"
          min-width="120"
          align="center"
        >
          <template slot-scope="scope">
            <i
              class="el-icon-check"
              v-if="scope.row.content_type==1"
            ></i>
            <span v-else></span>
          </template>
        </el-table-column>

        <el-table-column
          prop="remark"
          label="备注"
          min-width="160"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{scope.row.remark || '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="sort"
          label="排序值"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="创建时间"
          min-width="180"
          align="center"
        >
          <template slot-scope="scope">{{$moment(scope.row.create_time).format('YYYY-MM-DD HH:mm:SS')}}</template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180"
          align="center"
          fixed="right"
          v-if="isfixed"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="handleToEdit(scope.row, scope.$index)"
            >编辑</el-button>
            <el-button
              size="mini"
              type="text"
              v-if="scope.row.type == 1"
              @click="handleToRuleAdd(scope.row, scope.$index)"
            >添加子参数</el-button>
            <el-button
              size="mini"
              style="color:#f56c6c"
              type="text"
              @click="handleDelete(scope.row, scope.$index)"
            >删除</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label=""
          width="40"
          align="center"
          fixed="right"
          v-else
        >
          <template slot-scope="scope">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                ...
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  command="a"
                  style="margin-bottom:6px;"
                ><span
                    @click="handleToEdit(scope.row, scope.$index)"
                    style="font-size:16px;color: #409EFF;"
                  >
                    编辑
                  </span></el-dropdown-item>
                <el-dropdown-item
                  command="b"
                  style="margin-bottom:6px;"
                ><span
                    @click="handleToRuleAdd(scope.row, scope.$index)"
                    style="font-size:16px;color: #409EFF;"
                  >
                    添加子参数
                  </span></el-dropdown-item>
                <el-dropdown-item
                  command="d"
                  style="margin-bottom:6px;"
                ><span
                    @click="handleDelete(scope.row, scope.$index)"
                    style="font-size:16px;color: #F56C6C;"
                  >
                    删除
                  </span></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <ParamCreate
      :visible="createDialog"
      :content="addRow"
      @close="createDialog=false"
      @submit="fetchList"
    ></ParamCreate>
    <ParamEdit
      :visible="editDialog"
      :content="editRow"
      @close="editDialog=false"
      @submit="fetchList"
    ></ParamEdit>
  </div>
</template>
<script>
import { paramlist, paramDelete, collegeBasiclist } from "@/api/query";
import ParamCreate from "@/components/dialog/query/ParamCreate";
import ParamEdit from "@/components/dialog/query/ParamEdit";

export default {
  components: {
    ParamCreate,
    ParamEdit
  },
  data() {
    return {
      createDialog: false,
      editDialog: false,
      query: {
        isPaging: 0,
      },
      rules: [],
      editRow: {},
      addRow: {},
      isfixed: document.body.clientWidth < 820 ? false : true,
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    // 参数列表
    fetchList() {
      paramlist(this.query).then((res) => {
        this.rules = res.list || [];
        this.pageTotal = res.count || 0;
      });
    },
    // 参数创建
    handleParamCreate() {
      this.createDialog = true;
    },
    // 参数编辑
    handleToEdit(row, $index) {
      this.editRow = Object.assign({}, row, { status: row.status == 1 ? true : false })
      if (row.pid) {
        this.editRow.parent = this.findRuleInfo(row.pid)
      }
      this.editDialog = true;
    },
    // 子参数创建
    handleToRuleAdd(item, $index) {
      this.addRow = item;
      this.createDialog = true;
    },
    handleDelete(item, index) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        paramDelete({ id: item.id }).then((res) => {
          this.$message.success(`删除成功`)
          this.fetchList()
        })
      }).catch(() => { })
    },
    // 获取参数详情
    findRuleInfo(id, rules) {
      let rule = null;
      (rules || this.rules).some(item => {
        if (item.id == id) {
          rule = item
          return true
        }
        if (item.children) {
          rule = this.findRuleInfo(id, item.children)
          if (rule) {
            return true
          }
        }
      })
      return rule
    }
  },
};
</script>

<style scoped lang="less">
.admin {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>

